import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';

import { useAuth } from '../contexts/auth';
import { apolloClient } from './apollo';
import QueryProtectedContent from './protected-content.graphql';

export const useProtectedContentQuery = (id: string) => {
	const { session } = useAuth();

	const { data, error, loading } = useQuery(QueryProtectedContent, {
		client: apolloClient,
		context: { accessToken: session?.accessToken },
		variables: { id },
		errorPolicy: 'all',
	});

	return { data, loading, error };
};

import QueryProtectedArticle from './protected-article.graphql';

export const useProtectedArticleQuery = (id: string) => {
	const { session } = useAuth();

	const { data, error, loading } = useQuery(QueryProtectedArticle, {
		client: apolloClient,
		context: { accessToken: session?.accessToken },
		variables: { id },
	});

	return { data, loading, error };
};
